import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

function SummaryReactivationGraph(props) {
  const hniRetail = props.hniRetailData;
  const reactivation = hniRetail?.aboveSixMnthPer
    ? hniRetail?.aboveSixMnthPer.toFixed(2)
    : 0;
  const reactivationPer = Number(reactivation);
  const clientInService = hniRetail?.threeTosixMnthPer
    ? hniRetail?.threeTosixMnthPer.toFixed(2)
    : 0;
  const clientInservicePer = Number(clientInService);
  const clientHandover = hniRetail?.threeMnthPer
    ? hniRetail?.threeMnthPer.toFixed(2)
    : 0;
  const clientHandoverPer = Number(clientHandover);

  const SumarryChart = {
    credits: {
      enabled: false,
    },

    chart: {
      type: "solidgauge",
      // height: '110%',
      height: 280,
      width: 200,
      //   plotAreaWidth: 0,
      //   plotAreaHeight: 0,
      // events: {
      //     render: renderIcons
      // }
    },

    title: {
      text: props.title,
      align: "center",
      verticalAlign: "middle",
      style: {
        fontSize: "20px",
      },
      y: 20, // for title top margin
    },
    // title: {
    //     text: null,
    //     style: {
    //         fontSize: '24px'
    //     }
    // },

    legend: {
      enabled: false,
    },

    tooltip: {
      enabled: false,
      borderWidth: 0,
      backgroundColor: "none",
      shadow: false,
      style: {
        fontSize: "10px",
      },
      valueSuffix: "%",
      pointFormat:
        '{series.name}<br><span style="font-size:2em; color: {point.color}; font-weight: bold">{point.y}</span>',
      positioner: function (labelWidth) {
        return {
          x: (this.chart.chartWidth - labelWidth) / 2,
          y: this.chart.plotHeight / 2 + 15,
        };
      },
    },

    pane: {
      startAngle: -179,
      endAngle: 179,
      background: [
        {
          // Track for Move
          // outerRadius: '112%',
          // innerRadius: '88%',
          outerRadius: "100%",
          innerRadius: "90%",
          backgroundColor: "#0dbf8d" + "25",
          borderWidth: 0,
        },
        {
          // Track for Exercise
          outerRadius: "80%",
          innerRadius: "70%",
          backgroundColor: "#feda7c" + "45",
          borderWidth: 0,
        },
        {
          // Track for Stand
          outerRadius: "60%",
          innerRadius: "50%",
          backgroundColor: "#ff86b1" + "35",
          borderWidth: 0,
        },
      ],
    },

    yAxis: {
      min: 0,
      max: 100,
      lineWidth: 0,
      tickPositions: [],
    },

    plotOptions: {
      solidgauge: {
        dataLabels: {
          enabled: false,
        },
        linecap: "round",
        stickyTracking: false,
        rounded: true,
      },
    },

    series: [
      {
        name: "Client Handover",
        data: [
          {
            color: "#0dbf8d",
            radius: "100%",
            innerRadius: "90%",
            y: clientHandoverPer,
          },
        ],
      },
      {
        name: "Clients in service",
        data: [
          {
            color: "#feda7c",
            radius: "80%",
            innerRadius: "70%",
            y: clientInservicePer,
          },
        ],
      },
      {
        name: "Reactivation",
        data: [
          {
            color: "#ff86b1",
            radius: "60%",
            innerRadius: "50%",
            y: reactivationPer,
          },
        ],
      },
    ],
  };

  return (
    <>
      <HighchartsReact highcharts={Highcharts} options={SumarryChart} />
    </>
  );
}

export default SummaryReactivationGraph;
